import moment from "moment";
import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import { Booking } from "sweet-global";
import BookingControls from "sweet-web/components/Booking/Controls";
import EditBooking from "sweet-web/components/Booking/EditBooking";
import ViewBooking from "sweet-web/components/Booking/ViewBooking";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import {
  Badge,
  Label,
  SectionTitle,
  Title
} from "sweet-web/components/universal/Text";
import { fadeIn } from "sweet-web/lib/animations";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 400px;
  min-width: 300px;
  width: 100%;
  padding: 20px;
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const BookingComponent: React.FC<Props> = props => {
  const { chatId } = props.match.params as { chatId: string };
  const { booking, userType } = props;

  const canEdit = (booking: Booking): boolean => {
    return (
      booking.status === "INQUIRY" ||
      (booking.status === "PROPOSED" && userType === "VENUE")
    );
  };

  const [editable, setEditable] = useState(canEdit(booking));

  useEffect(() => {
    setEditable(canEdit(booking));
  }, [booking.status]);

  return (
    <Wrapper>
      <Title style={{ marginBottom: 5 }}>Booking</Title>
      {booking.status === "INQUIRY" && (
        <Badge
          style={{ marginBottom: 10 }}
          color={colors.nearWhite}
          textColor={colors.primary}
        >
          Inquiry
        </Badge>
      )}
      {booking.status === "PROPOSED" && (
        <Badge
          style={{ marginBottom: 10 }}
          color={colors.nearWhite}
          textColor={colors.primary}
        >
          Proposal
        </Badge>
      )}
      {booking.status === "CONFIRMED" && (
        <Badge
          style={{ marginBottom: 10 }}
          color={colors.nearWhite}
          textColor={colors.green}
        >
          Confirmed
        </Badge>
      )}
      {booking.status === "COMPLETED" && (
        <Badge
          style={{ marginBottom: 10 }}
          color={colors.nearWhite}
          textColor={colors.green}
        >
          Completed
        </Badge>
      )}
      {booking.status === "CANCELLED" && (
        <Badge
          style={{ marginBottom: 10 }}
          color={colors.nearWhite}
          textColor={colors.gray}
        >
          Cancelled
        </Badge>
      )}
      {editable && <EditBooking bookingId={booking.id} />}
      {!editable && <ViewBooking bookingId={booking.id} />}
      <BookingControls />
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { chatId } = ownProps.match.params as { chatId: string };

  return {
    booking: selectors.getBookingByChat(chatId)(state),
    userType: selectors.userType(state)
  };
};
const mapDispatch = (dispatch: Dispatch) => bindActionCreators({}, dispatch);
const connector = connect(mapState, mapDispatch);

export default withRouter(connector(BookingComponent));
